import type { FailureCashOutFromBackend, SuccessCashOutFromBackend } from './types';

// TODO: нужно как-то архитектурно продумать передачу типов в сервисы
import { EntriesStateType } from 'app/modules/MyStakes/constants';

import { URL } from '../../../constants';
import type { ServiceConfig } from '../../../utils/create-http-api-service';
import { defaultRequestService } from '../../../utils/default-request-service';

// ---

export const cashOutAmount = (
  config: ServiceConfig,
  props: { stakeId: number; namespace: EntriesStateType },
) => {
  type AdapterProps = { response: SuccessCashOutFromBackend };

  const url = `${URL.CASH_OUT_AMOUNT}?stakeId=${props.stakeId}`;

  return defaultRequestService<AdapterProps, void, FailureCashOutFromBackend>(
    url,
    config.instance.get,
  );
};
